/**
 * @Description:
 * @Author: huage
 * @Date: 2020/9/17
 */
export default {
    common: {
        "confirm": "確認",
        "cancle": "取消",
        "add": "新增",
        "edit": "編輯",
        "delete": "删除",
        "save": "保存",
        "disable": "禁用",
        "enable": "啟用",
        "back": "返回",
        "message1": "修改密碼成功",
        "placeholder1": "請輸入新密碼",
        "placeholder2": "請輸入確認密碼",
        "placeholder3": "數字、字母、中劃線或下劃線組合",
        "placeholder4": "請輸入用戶名",
        "placeholder5": "用戶名不能大於20個字符",
        "placeholder6": "只能輸入數字、字母、中劃線或下劃線",
        "placeholder7": "請選擇",
      }
};


// WEBPACK FOOTER //
// ./src/config/langs/tc/common.js